import graphqlClient from '~/graphql/graphqlClient';

export type PurchaseShopItemArgs = {
  playerId: string;
  itemId: string;
};

export type PurchaseShopItemResult = {
  success: boolean;
  inventory?: any;
  shopInventory?: any[];
  last_restock?: number;
  currency1?: number;
  currency2?: number;
  error?: string;
};

const mutation = `
mutation PurchaseShopItem($playerId: String!, $itemId: String!) {
  purchaseShopItem(playerId: $playerId, itemId: $itemId) {
    success
    inventory
    shopInventory
    last_restock
    currency1
    currency2
    error
  }
}
`;

export default async function mutationPurchaseShopItem(
  args: PurchaseShopItemArgs
): Promise<PurchaseShopItemResult> {
  return await graphqlClient.request<PurchaseShopItemResult>(
    'purchaseShopItem',
    mutation,
    args
  );
}
